import { Observable } from 'rxjs';

export abstract class Step {
  readonly icon?: string | any;
  readonly step: number;
  readonly tabHeader: string;
  abstract route: string;
  abstract isComplete$: Observable<boolean>;
}
